import React, { useEffect, useState } from 'react';
import ReactHighCharts from 'react-highcharts';

const SyncAnalysis = (props) => {
  const [config, setConfig] = useState({ chart: { type: 'column' } });

  useEffect(() => {
    setConfig({
      chart: { zoomType: 'x', panning: true, panKey: 'shift', type: 'column' },
      xAxis: { type: 'datetime' },
      series: [
        { name: 'Delta T1', data: props.data.map((value) => (value[4] === 'Full' ? value[1] : null)) },
        { name: 'Delta T2', data: props.data.map((value) => (value[4] === 'Full' ? value[2] : null)) },
        { name: 'Delta T3', data: props.data.map((value) => (value[4] === 'Full' ? value[3] : null)) },
        { name: 'Delta T1 Match', data: props.data.map((value) => (value[4] === 'match' ? value[1] : null)) },
        { name: 'Delta T2 Match', data: props.data.map((value) => (value[4] === 'match' ? value[2] : null)) },
        { name: 'Delta T3 Match', data: props.data.map((value) => (value[4] === 'match' ? value[3] : null)) },
      ],
      responsive: {
        rules: [{ condition: { maxWidth: 500 }, chartOptions: { legend: { layout: 'horizontal', align: 'center', verticalAlign: 'bottom' } } }],
      },
    });
  }, [props.data]);

  return <div><ReactHighCharts config={config} /></div>;
};

export default SyncAnalysis;



// WEBPACK FOOTER //
// src/components/appareils/SyncAnalysis.js